import React, { useEffect } from 'react';

const SummaryProperties = ({ block, onUpdate, allBlocks }) => {
    const fonts = ['Lato', 'Roboto', 'Montserrat', 'Open Sans', 'Poppins'];
    const anchors = allBlocks.filter(b => b.isAnchor);
    const summaryItems = block.content || [];

    const handleLabelChange = (anchorId, newLabel) => {
        let itemExists = false;
        const newItems = summaryItems.map(item => {
            if (item.anchorId === anchorId) {
                itemExists = true;
                return { ...item, label: newLabel };
            }
            return item;
        });

        if (!itemExists) {
            newItems.push({ anchorId, label: newLabel });
        }
        
        onUpdate(block.id, { content: newItems });
    };
    
    useEffect(() => {
        let needsUpdate = false;
        const newItems = [...summaryItems];
        // Add new anchors if they don't exist in the summary
        anchors.forEach(anchor => {
            if (!newItems.find(item => item.anchorId === anchor.id)) {
                newItems.push({ anchorId: anchor.id, label: anchor.content });
                needsUpdate = true;
            }
        });

        // Remove summary items if their anchor was deleted
        const anchorIds = anchors.map(a => a.id);
        const filteredItems = newItems.filter(item => anchorIds.includes(item.anchorId));
        if (filteredItems.length !== newItems.length) {
            needsUpdate = true;
        }

        if(needsUpdate) {
            onUpdate(block.id, { content: filteredItems });
        }
    }, [anchors, summaryItems, block.id, onUpdate]);

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium">Liens du sommaire</label>
                <div className="space-y-2 mt-1">
                    {anchors.map(anchor => {
                        const summaryItem = summaryItems.find(item => item.anchorId === anchor.id);
                        const currentLabel = summaryItem ? summaryItem.label : anchor.content;
                        return (
                            <div key={anchor.id}>
                                <label className="block text-xs text-gray-500">Lien vers: "{anchor.content}"</label>
                                <input 
                                    type="text"
                                    value={currentLabel}
                                    onChange={(e) => handleLabelChange(anchor.id, e.target.value)}
                                    className="w-full p-1 border rounded mt-1"
                                />
                            </div>
                        );
                    })}
                    {anchors.length === 0 && <p className="text-xs text-gray-500">Aucune ancre trouvée. Ajoutez un bloc "Ancre" à votre design.</p>}
                </div>
            </div>
            
            <div className="pt-4 border-t">
                <h4 className="font-semibold">Style du Titre</h4>
                <div>
                    <label className="block text-sm font-medium">Taille ({block.titleFontSize || 20}px)</label>
                    <input type="range" min="12" max="48" value={block.titleFontSize || 20} onChange={(e) => onUpdate(block.id, { titleFontSize: parseInt(e.target.value) })} className="w-full" />
                </div>
                <div>
                    <label className="block text-sm font-medium">Couleur</label>
                    <input type="color" value={block.titleColor || '#000000'} onChange={(e) => onUpdate(block.id, { titleColor: e.target.value })} className="w-full h-8" />
                </div>
            </div>
            
            <div className="pt-4 border-t">
                <h4 className="font-semibold">Style des Liens</h4>
                <div>
                    <label className="block text-sm font-medium">Taille ({block.linksFontSize || 16}px)</label>
                    <input type="range" min="12" max="32" value={block.linksFontSize || 16} onChange={(e) => onUpdate(block.id, { linksFontSize: parseInt(e.target.value) })} className="w-full" />
                </div>
                <div>
                    <label className="block text-sm font-medium">Couleur</label>
                    <input type="color" value={block.linksColor || '#0000FF'} onChange={(e) => onUpdate(block.id, { linksColor: e.target.value })} className="w-full h-8" />
                </div>
            </div>

            <div className="pt-4 border-t">
                <label className="block text-sm font-medium">Marge haute ({block.paddingTop || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingTop || 0} onChange={(e) => onUpdate(block.id, { paddingTop: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge basse ({block.paddingBottom || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingBottom || 0} onChange={(e) => onUpdate(block.id, { paddingBottom: parseInt(e.target.value) })} className="w-full" />
            </div>
             <div>
                <label className="block text-sm font-medium">Marges latérales ({block.paddingLeft || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingLeft || 0} onChange={(e) => {
                    const value = parseInt(e.target.value);
                    onUpdate(block.id, { paddingLeft: value, paddingRight: value });
                }} className="w-full" />
            </div>
        </div>
    );
};

export default SummaryProperties;